<style src="./style.scss">
</style>

<script>
  import Modal from "@components/modal";
  import Button from "@components/button";
  import TextInput from "@components/textInput";
  import { isEmailValid } from '@utils/email';

  export let isOpen = false;
  export let onClose = () => null;
  export let onSubmit = () => null;
  export let currentEmail = '';
  export let error = '';
  
  let newEmail = currentEmail;

  const validaEmail = () => {
    error = '';
    const validEmail = isEmailValid(newEmail);
    if (!validEmail) error = 'E-mail inválido.';
  }

  const onInput = () => error = '';

</script>

<Modal isOpen="{isOpen}" title="Mudar e-mail" onClose="{onClose}">
  <form on:submit|preventDefault="{() => onSubmit(newEmail)}">
    <TextInput placeholder="E-mail" bind:value="{newEmail}" type="text" onBlur={validaEmail} onInput={onInput} />
    {#if error !== ''}
      <p class="error">{@html error}</p>
    {/if}
    <Button
      title="Salvar"
      onClick="{() => onSubmit(newEmail.trim())}"
      disabled="{!newEmail || (newEmail === currentEmail) || error !== ''}" />
  </form>
</Modal>
